import React from "react";
import { identity } from "lodash";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { retrieveFieldError } from "../../utils/formHelpers";
import useRequiredRule from "../../utils/useRequiredRule";
import FormField from "./FormField";
import TextInput from "./TextInput";

export default function TextField(props) {
  const {
    name,
    size,
    placeholder,
    label,
    hint,
    registerOptions,
    validate,
    disabled,
    required,
    transformValue = identity,
    labelSx,
    ...rest
  } = props;
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const error = retrieveFieldError(name, errors);

  const rules = useRequiredRule(required, registerOptions);

  const onChange = registerOptions?.onChange;

  /**
   * `required` marcava só o atributo HTML, e quem barrava o submit era a
   * validação nativa do browser. Com `noValidate` no Form, quem valida é o
   * react-hook-form — então o required precisa existir como regra dele, como o
   * MuiSelectField já faz. Em forms com resolver (yup) o RHF ignora estas
   * regras, então isto só alcança os campos que antes dependiam do HTML.
   */
  const requiredRule =
    required && registerOptions?.required === undefined
      ? { required: "Campo obrigatório" }
      : {};

  const handleOnChange = useCallback(
    (e) => {
      e.target.value = transformValue(e.target.value);
      !!onChange && onChange(e);
    },
    [transformValue, onChange]
  );

  return (
    <FormField
      label={label}
      hint={hint}
      error={error?.toString()}
      disabled={disabled}
      required={required}
      labelSx={labelSx}
    >
      <TextInput
        {...register(name, {
          ...requiredRule,
          ...registerOptions,
          onChange: handleOnChange,
        })}
        placeholder={placeholder}
        size={size}
        disabled={disabled}
        required={required}
        {...rest}
      />
    </FormField>
  );
}
